import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import './PWAUpdatePrompt.scss';

/**
 * PWAUpdatePrompt - Hiển thị thông báo khi có bản cập nhật mới của ứng dụng.
 * Sử dụng chiến lược "prompt for update" - người dùng tự quyết định thời điểm cập nhật.
 */
const PWAUpdatePrompt: React.FC = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered() {},
    onRegisterError(error) {
      console.error('[PWA] Service Worker registration error:', error);
    },
  });

  const handleClose = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  const handleUpdate = () => {
    updateServiceWorker(true);
  };

  if (!needRefresh && !offlineReady) return null;

  return (
    <div className="pwa-toast" role="alert" aria-live="polite">
      <div className="pwa-toast__content">
        <div className="pwa-toast__icon">
          {needRefresh ? (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="23 4 23 10 17 10" />
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
            </svg>
          ) : (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          )}
        </div>

        <div className="pwa-toast__message">
          {offlineReady ? (
            <p>Ứng dụng đã sẵn sàng hoạt động offline!</p>
          ) : (
            <p>
              Có phiên bản mới. Nhấn <strong>Cập nhật</strong> để áp dụng.
            </p>
          )}
        </div>

        <div className="pwa-toast__actions">
          {needRefresh && (
            <button
              className="pwa-toast__btn pwa-toast__btn--primary"
              onClick={handleUpdate}
              type="button"
            >
              Cập nhật
            </button>
          )}
          <button
            className="pwa-toast__btn pwa-toast__btn--close"
            onClick={handleClose}
            type="button"
            aria-label="Đóng thông báo"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAUpdatePrompt;
